import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import ProfileDetails from './ProfileDetails';
import CustomAvatar from '../elements/CustomAvatar';
import { getRoleLabel } from '../../lib/utils';
import { formatPhoneNumber } from '../../lib/utils';
const AccountProfile = ({ user, fetchUserData }) => {

  return (
    <Card>
      <CardContent>
        <Grid
          container
          alignItems="center"
          spacing={2}
          sx={{ position: 'relative' }}>
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            display="flex"
            justifyContent="center">
            <CustomAvatar
              firstName={user?.first_name}
              lastName={user?.last_name}
              showTitle={false}
              size={120}
            />
          </Grid>

          <Grid item xs={12} sm={8} md={9}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: { xs: 'center', sm: 'left' },
              }}>
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  fontWeight: '400',
                  color: '#333',
                }}>
                {[user?.first_name?.trim(), user?.last_name?.trim()]
                  .filter(Boolean)
                  .join(' ')}
              </Typography>

              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  marginTop: '8px',
                }}>
                Email: {user?.email}
              </Typography>

              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  marginTop: '8px',
                }}>
                Role: {getRoleLabel(user?.role)}
              </Typography>

              {user?.role !== 'super-admin' && <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  textTransform: 'capitalize',
                  marginTop: '8px',
                }}>
                Organization: {user?.organization_name}
              </Typography>}
              {user?.phone_number && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    fontSize: { xs: '0.9rem', sm: '1rem' },
                    marginTop: '8px',
                  }}>
                  Phone: {formatPhoneNumber(user.phone_number)}
                </Typography>
              )}
            </Box>
          </Grid>

          <ProfileDetails user={user} fetchUserData={fetchUserData} />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AccountProfile;
